import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

export default function Language({ useLanguages, useEvents }) {
  const [language, setLanguage, languages] = useLanguages

  const handleChange = (event) => {
    setLanguage(event.target.value)
  };

  return (
      <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
        <InputLabel id="select-language-label">Language</InputLabel>
          <Select
            labelId="select-language-label"
            id="select-language"
            value={language}
            label="Language"
            onChange={handleChange}
            onMouseOver={useEvents.onMouseOver}
            onMouseOut={useEvents.onMouseOut}
          >
            <MenuItem value={language}>
              <em>{language}</em>
            </MenuItem>
            {
                languages.filter(
                    (lang) => language != lang
                ).map(
                    (language) => <MenuItem key={language} value={language}>{language}</MenuItem>
                )
            }
          </Select>
    </FormControl>
  )
}